import {useAttendeeVariables} from 'Event'
import {FieldProps} from 'Event/Question'
import HTMLContent from 'lib/ui/form/HTMLEditor/HTMLContent'
import {QuestionBase} from 'organization/Event/QuestionsProvider'
import React from 'react'

export const CONTENT = 'content'

export type ContentOnlyQuestion = QuestionBase & {
  type: typeof CONTENT
}

export default function Content(props: FieldProps) {
  const v = useAttendeeVariables()

  return (
    <HTMLContent aria-label="form content">
      {v(props.question.label)}
    </HTMLContent>
  )
}
